import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initConsent } from './lib/consent';
import './index.css';

// Boot-time consent wiring: honor Sec-GPC and re-assert the Plausible
// opt-out flag before React mounts so the notice bar reads post-GPC state.
initConsent();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
